module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-blob-16-36d1a6e43c5dfcece39a42b78def217f.svg";